import React, {Component} from "react";
import {connect} from "react-redux";
import Modal from "../../../../global/generic/Modal";
import * as modelHelper from "../../../../../helpers/modelHelper";
import {Translate, translate} from "react-i18nify";
import * as navigationActions from "../../../../../actions/navigationActions";
import * as componentTypes from "../../../../../constants/componentTypes";
import Input from "../../../../global/generic/Input";
import * as windowService from "../../../../../services/windowService";
import Button from "../../../../global/generic/Button";
import CancelButton from "../../../../global/generic/CancelButton";
import imgAnalyse from "../../../../../resources/img/svgicons/file-magnifying-glass.svg";
import imgAnalyseSolid from "../../../../../resources/img/svgicons/file-magnifying-glass-solid.svg";
import imgCheckSolid from "../../../../../resources/img/svgicons/file-check-solid.svg";
import imgLoader from "../../../../../resources/img/loader.svg";
import imgUpload from "../../../../../resources/img/svgicons/file-arrow-up.svg";
import imgUploadSolid from "../../../../../resources/img/svgicons/file-arrow-up-solid.svg";
import {ReactSVG} from "react-svg";
import * as serverActions from "../../../../../actions/serverActions";
import * as handlers from "../../../../../constants/handlers";
import CloseButton from "../../../../global/generic/CloseButton";
import imgDownload from "../../../../../resources/img/svgicons/download.svg";

class DatabaseFromExcelModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            secondsToRestart: null,
            restartInterval: null,
            excelFile: this.props.params?.excelFile ?? "",
            productFilesPath: this.props.params?.productFilesPath ?? "",
            productImagesPath: this.props.params?.productImagesPath ?? "",
            overwriteLocalData: this.props.params?.overwriteLocalData ?? true
        };

        if (this.state.excelFile !== "") {
            this.doAnalysis();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.result === true && this.props.result !== prevProps.result) {
            this.startRestartCountdown();
        }
    }

    startRestartCountdown = () => {
        this.setSecondsToRestart();
        this.setState({restartInterval: setInterval(this.setSecondsToRestart, 1000)});
    };

    setSecondsToRestart = () => {
        if (this.state.secondsToRestart === null) {
            this.setState({secondsToRestart: 10});
            return;
        }

        if (this.state.secondsToRestart === 0) {
            clearInterval(this.state.restartInterval);
            this.setState({secondsToRestart: null, restartInterval: null});
            this.props.dispatchUpdateDatabases();
            if (this.props.params?.excelFile) {
                windowService.restartRedlike();
            }
            this.onClose();
            return;
        }

        this.setState({secondsToRestart: this.state.secondsToRestart - 1});
    };

    onClose = () => {
        this.props.dispatchCloseModalAction();
    };

    changePath = (filename, property) => {
        this.setState({
            [property]: filename
        });
    };

    handleSelectFileClick = (event) => {
        windowService.openSelectFileDialog("", (filename) => this.changePath(filename, event.target.dataset.property), [
            "xls",
            "xlsx"
        ]);
    };

    handleSelectDirectoryClick = (event) => {
        windowService.openSelectDirectoryDialog((filename) => this.changePath(filename, event.target.dataset.property));
    };

    getLabelInputRow = (translation, required, value, property, onBrowse) => {
        return (
            <div className="col-12 flex flex-wrap flex-align-center-vertical">
                <div className="col-4 flex">
                    <Translate value={translation} />
                    {required ? "*" : null}:
                </div>
                <Input
                    className="primary-input fill-flex-space"
                    type="text"
                    readOnly
                    value={value}
                    labelAfter={
                        <label className="cursor-pointer" onClick={onBrowse}>
                            <span data-property={property} className="padding-10">
                                ...
                            </span>
                        </label>
                    }
                />
            </div>
        );
    };

    getNumberOfItemsCount = (item, count) => {
        return <span className="">{translate("general.numberOfItemCount", {item, count})}</span>;
    };

    getProgressBar = () => {
        const step = translate(`general.${this.props.step?.toLowerCase() ?? "settings"}`);
        const item = this.props.item;
        const total = this.props.total;

        return (
            <React.Fragment>
                <div className="col-12 flex margin-top-10 font-size-1_25em">
                    {step && <span className="color-primary">{translate("general.processingStep", {step})}...</span>}
                    {item && total && (
                        <span className="margin-left-auto">{translate("general.itemXOfY", {x: item, y: total})}</span>
                    )}
                </div>
                {item && total && (
                    <div className="progress col-12">
                        <div
                            className="progress-bar"
                            role="progressbar"
                            aria-valuenow={item}
                            aria-valuemin={1}
                            aria-valuemax={total}
                            style={{width: (item / total) * 100 + "%"}}
                        >
                            {item + "/" + total} ({((item / total) * 100).toFixed(0) + "%"})
                        </div>
                    </div>
                )}
            </React.Fragment>
        );
    };

    getModalContent = () => {
        // import progress
        if (this.props.loading && !!this.props.stats) {
            return modelHelper.buildModalSection(
                <React.Fragment>
                    <img style={{maxHeight: "50px"}} alt="file-import" src={imgUploadSolid} />
                    <span className="font-2vh margin-bottom-10">{translate("addDatabase.importingYourData")}...</span>
                    {this.getProgressBar()}
                </React.Fragment>,
                "flex flex-column flex-align-center-vertical"
            );
        }
        // analysis progress
        if (this.props.loading && !this.props.stats) {
            return modelHelper.buildModalSection(
                <React.Fragment>
                    <img style={{maxHeight: "50px"}} alt="file-analysis" src={imgAnalyseSolid} />
                    <span className="font-2vh">{translate("addDatabase.analysingYourData")}...</span>
                    <img alt="loading" src={imgLoader} />
                </React.Fragment>,
                "flex flex-column flex-align-center-vertical"
            );
        }

        // waiting for restart
        if (this.props.result === true) {
            return modelHelper.buildModalSection(
                <React.Fragment>
                    <ReactSVG
                        className="react-svg-icon fill-success fit-image"
                        style={{maxHeight: "50px", maxWidth: "50px"}}
                        alt="file-success"
                        src={imgCheckSolid}
                    />
                    <span className="font-2vh margin-bottom-10 color-success">
                        {translate("addDatabase.databasePrepared")}
                    </span>
                    <span className="margin-top-10">
                        {translate("general.softwareRestartInSeconds", {
                            software: this.props.softwareName,
                            seconds: this.state.secondsToRestart
                        })}
                    </span>
                </React.Fragment>,
                "flex flex-column flex-align-center-vertical margin-bottom-10 margin-top-10"
            );
        }

        if (this.props.log && this.props.log !== []) {
            return modelHelper.buildModalSection(
                <React.Fragment>
                    <span className="font-1_5vh color-warning">{translate("addDatabase.databaseNotImported")}</span>
                    <span className="font-1_5vh margin-bottom-10 color-warning">
                        {translate("addDatabase.fixErrors")}:
                    </span>
                    <div className="flex flex-column flex-child fill-flex-space slim-scroll">
                        {this.props.log.map((error, i) => (
                            <span key={i}>{error}</span>
                        ))}
                    </div>
                </React.Fragment>,
                "flex flex-column margin-bottom-10 margin-top-10"
            );
        }

        //analysis done
        if (this.props.stats) {
            return modelHelper.buildModalSection(
                <React.Fragment>
                    <span className="color-success font-2vh margin-bottom-10">
                        {translate("addDatabase.fileInformation")}:
                    </span>
                    {this.getNumberOfItemsCount(translate("general.colorants"), this.props.stats.colorants)}
                    {this.getNumberOfItemsCount(translate("general.products"), this.props.stats.products)}
                    {this.getNumberOfItemsCount(translate("general.fandecks"), this.props.stats.fandecks)}
                    {this.getNumberOfItemsCount(translate("general.colors"), this.props.stats.colors)}
                    {this.getNumberOfItemsCount(translate("general.formulas"), this.props.stats.formulas)}
                </React.Fragment>,
                "flex flex-column"
            );
        }

        return modelHelper.buildModalSection(
            <React.Fragment>
                {this.getLabelInputRow(
                    "addDatabase.excelFile",
                    true,
                    this.state.excelFile,
                    "excelFile",
                    this.handleSelectFileClick
                )}
                {this.getLabelInputRow(
                    "addDatabase.productImagesPath",
                    false,
                    this.state.productImagesPath,
                    "productImagesPath",
                    this.handleSelectDirectoryClick
                )}
                {this.getLabelInputRow(
                    "addDatabase.productFilesPath",
                    false,
                    this.state.productFilesPath,
                    "productFilesPath",
                    this.handleSelectDirectoryClick
                )}
            </React.Fragment>,
            "flex-column flex-row-gap-10px"
        );
    };

    doAnalysis = () => {
        this.props.dispatchInstallDatabaseExcelAction(
            this.state.excelFile,
            this.state.productFilesPath,
            this.state.productImagesPath,
            true,
            this.state.overwriteLocalData
        );
    };

    doImport = () => {
        this.props.dispatchInstallDatabaseExcelAction(
            this.state.excelFile,
            this.state.productFilesPath,
            this.state.productImagesPath,
            false,
            this.state.overwriteLocalData
        );
    };

    getModalFooter = () => {
        // analysis progress
        // import progress
        if (this.props.loading || this.props.result === true) {
            return null;
        }

        if (this.props.log && this.props.log !== []) {
            return modelHelper.buildModalSection(
                <React.Fragment>
                    <Button
                        svgBefore={imgDownload}
                        onClick={() =>
                            windowService.openSaveDialog(
                                /* eslint-disable-next-line no-undef */
                                Buffer.from(this.props.log.join("\n")).toString("base64"),
                                "log.txt"
                            )
                        }
                        label={"Log"}
                    />
                    <CloseButton onClick={this.onClose} />
                </React.Fragment>
            );
        }

        // Analysis done
        if (this.props.stats) {
            return modelHelper.buildModalSection(
                <React.Fragment>
                    <Button svgBefore={imgUpload} label={translate("importData.import")} onClick={this.doImport} />
                    <CancelButton onClick={this.onClose} />
                </React.Fragment>
            );
        }

        // File selection
        return modelHelper.buildModalSection(
            <React.Fragment>
                <Button svgBefore={imgAnalyse} label={translate("addDatabase.analyse")} onClick={this.doAnalysis} />
                <CancelButton onClick={this.onClose} />
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                header={modelHelper.buildModalSection(translate("addDatabase.databaseImport"))}
                content={this.getModalContent()}
                footer={this.getModalFooter()}
                onClose={this.onClose}
                styles={{
                    minWidth: "60%"
                }}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        loading: store.server.requests.some((request) => request.method === handlers.INSTALL_DATABASE_FILE_EXCEL),
        softwareName: store.settings.softwareName,
        stats: store.server.excelFileStats,
        step: store.server.excelFileStep,
        item: store.server.excelFileItem,
        total: store.server.excelFileTotal,
        result: store.server.excelFileResult,
        log: store.server.excelFileLog
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.DATABASE_FROM_EXCEL_MODAL));
        },
        dispatchInstallDatabaseExcelAction: (
            path,
            productFilesPath,
            productImagesPath,
            analyzeOnly,
            overwriteLocalData
        ) => {
            dispatch(
                serverActions.installDatabaseExcel(
                    path,
                    productFilesPath,
                    productImagesPath,
                    analyzeOnly,
                    overwriteLocalData
                )
            );
        },
        dispatchUpdateDatabases: () => {
            dispatch(serverActions.updateDatabases());
        }
    };
};

export default DatabaseFromExcelModal = connect(mapStoreToProps, mapDispatchToProps)(DatabaseFromExcelModal);
